import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonImg } from '@ionic/angular/standalone';

@Component({
  selector: 'app-slip-component-status-reason',
  templateUrl: './slip-component-status-reason.component.html',
  styleUrls: ['./slip-component-status-reason.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonImg]
})
export class SlipComponentStatusReasonComponent {
  @Input() iconSrc: string;
  @Input() heading: string;
  @Input() message: string;
}
